// src/pages/PaymentCancel.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import { Box, Typography, Button, Alert, CircularProgress } from '@mui/material';
import { ErrorOutline, ArrowBack } from '@mui/icons-material';

const PaymentCancel = () => {
    const location = useLocation();
    const [status, setStatus] = useState('Checking...');
    const [isDeleting, setIsDeleting] = useState(true);

    const registrationPath = '/techsummit2025'; 
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const registrationId = params.get('registration_id');

        if (!registrationId) {
            // No ID in URL, skip deletion and just display the cancel message
            setIsDeleting(false);
            setStatus('Ready');
            return;
        }

        const deleteRegistration = async () => {
            try {
                // Call the new DELETE endpoint on your BFF (port 5000)
                await axios.delete(
                    `${API_BASE_URL}/api/techsummit2025/registration?registrationId=${registrationId}`
                );
                
                setStatus('Deleted');
            } catch (error) {
                console.error("Failed to delete cancelled registration:", error);
                setStatus('Deletion Error');
                // The page still shows the cancellation message even if deletion fails
            } finally {
                setIsDeleting(false);
            }
        };

        deleteRegistration();
    }, [location.search, API_BASE_URL]);

    return (
        <Box 
            sx={{ 
                maxWidth: 600, 
                mx: 'auto', 
                mt: 6, 
                p: 4, 
                boxShadow: 3, 
                borderRadius: 3,
                textAlign: 'center'
            }}
        >
            <ErrorOutline color="error" sx={{ fontSize: 60, mb: 2 }} />
            
            <Typography variant="h4" gutterBottom>
                Registration Incomplete
            </Typography>

            {isDeleting ? (
                <Box sx={{ my: 3 }}>
                    <CircularProgress size={24} sx={{ mr: 1 }} />
                    <Typography variant="body1">Securing your record...</Typography>
                </Box>
            ) : (
                <>
                    <Alert severity={status === 'Deleted' ? "success" : "warning"} sx={{ mb: 3 }}>
                        {status === 'Deleted' 
                            ? "Your pending registration record has been safely removed from our system. No payment was processed."
                            : "It looks like you didn't complete your payment. No charge has been made to your card."}
                    </Alert>
                    
                    <Typography variant="body1" sx={{ mb: 4 }}>
                        If you still wish to register, please try again below.
                    </Typography>

                    <Button 
                        variant="contained" 
                        color="primary" 
                        size="large"
                        startIcon={<ArrowBack />}
                        component={Link} 
                        to={registrationPath} 
                    >
                        Return to Registration
                    </Button>
                </>
            )}
            
            <Typography variant="body2" sx={{ mt: 3, color: 'text.secondary' }}>
                Need help? Contact support at info@udyogconnect.org
            </Typography>
        </Box>
    );
};

export default PaymentCancel;
